<template>
    <div>
        <Wp_nav_bar title="切换账号"></Wp_nav_bar>

        <div v-if="account_list && account_list.length > 0">
            <van-cell-group >
                <van-cell v-for="(item, index) in account_list" :key="index"
                        :title="item.u_name" is-link value="登录" :border="true" size="large" @click="auto_login(item, index)">
                    <div slot="title" style="">
                        <span style="font-size: 18px">{{item.u_name}}</span>

                        <van-tag v-if="index === 0" type="success" style="margin-left: 5px; font-size: 10px; position: absolute; top: 14px" >当前使用</van-tag>
                    </div>

                    <span v-if="index === 0" slot="default">返回</span>
                </van-cell>
            </van-cell-group>
        </div>
    </div>
    
</template>

<script>
    import Wp_nav_bar from "../custom/Wp_nav_bar";
    export default {
        name: "Wp_my_change_account",
        components: {Wp_nav_bar},
        data(){
            return{
                account_list: [],
            }
        },

        created(){
            this.initAccountList();
        },

        methods:{
            /**
             * 初始化（将当前使用的账号置于第一位，以保证当前使用的账号的index一直为0）
             */
            initAccountList(){
                let arr = this.$common.gloabl_account_list;
                if(arr && arr.length > 0){
                    if(arr[0].u_name !== this.$store.state.username){

                        let temp_item = null;
                        for(let i = 0; i < arr.length; i ++){
                            if(arr[i].u_name === this.$store.state.username){
                                //将当前账户数据存储
                                temp_item = arr[i];
                                //删除
                                arr.splice(i, 1);
                                break;
                            }
                        }
                        //将当前账户数据添加到数组第一位
                        arr.unshift(temp_item);
                    }
                }
                this.account_list = arr;
            },

            // isCurrentAccount(item){
            //     if(item.u_name === this.$store.state.username){
            //         return true;
            //     }else{
            //         return false;
            //     }
            // },

            /**
             * 自动登录
             */
            auto_login(item, index){
                if(this.account_list && this.account_list.length > 0){

                    if(index === 0){
                        this.onClickBack();
                        return;
                    }

                    // if(this.isCurrentAccount(item)){
                    //     this.onClickBack();
                    //     return;
                    // }

                    let params = {
                        uname: item.u_name,
                        upwd: item.u_pwd
                    };

                    this.$auto_login(params, response=>{
                        this.$log(response)
                        if (response && response.code === 200) {
                            let loginInfo = response.data[0];
                            let user = {
                                username: loginInfo.u_name,
                                userId: loginInfo.id,
                                pid: loginInfo.u_pid,
                                alipay: loginInfo.u_alpay,//支付宝账号
                                bankName: loginInfo.u_bank,//开户行
                                cardNomber: loginInfo.u_card,//银行卡号
                                bank_account: loginInfo.u_bank_account,// 账号名称
                                openid: loginInfo.u_openid,//微信openid
                                truename: loginInfo.u_payname,// 真实姓名
                                userType: loginInfo.u_type,// 0群主1代理商
                                userPhone: loginInfo.u_phone,//手机号
                                taobao_pid: loginInfo.taobao_pid,//淘宝pid
                            };
                            this.$store.commit('login', user);

                            //登录成功后，刷新页面
                            this.$dialog.alert({
                                title: "切换账号成功",
                                message: "账号已切换为：" +  item.u_name
                            }).then(()=>{
                                this.$common.gloabl_account_list = [];
                                window.location.replace("/index.html");
                            })
                        } else {
                            this.msg = response.msg;
                            this.$dialog.alert({message: this.msg});
                        }
                    })
                }
            },

            /**
             * 获取指定手机号下所有的账号信息
             */
            // getAccountListByPhone(){
            //     if(this.phone){
            //         let params = {
            //             phone: this.phone
            //         };
            //
            //         this.$getAccountListByPhone(params, response=>{
            //             this.$log(response)
            //             // {msg: "成功", code: 200, data: Array(2)}
            //             if(response && response.code === 200){
            //                 this.account_list = response.data;
            //                 if(this.account_list && this.account_list.length === 1 && this.account_list[0].u_name === this.$store.state.username){
            //                     this.$dialog.alert({
            //                         title: this.account_list[0].u_name,
            //                         message: "您只有一个账号，切换功能不可用"
            //                     })
            //                 }
            //             }
            //         })
            //     }
            // },

        }
    }
</script>

<style scoped>

</style>